"use client";

import React from "react";
import { Dialog, Modal } from "staysure-component-library";

import { PostalSettingModalProps } from "@/types/review-types";

import RemoveSureModalContent from "../review-modal-content/remove-sure-modal-content";

function AreYouSurePostalModal({
  isOpen,
  setIsOpen,
  content,
  onChange,
}: Readonly<PostalSettingModalProps>) {
  return (
    <Modal
      onOpenChange={(e: boolean) => {
        setIsOpen(e);
        if (!e && onChange) onChange(0);
      }}
      isOpen={isOpen}
      modalStyles={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className=" bg-surface-neutral-option-1 w-[312px] md:w-[416px] items-center justify-center  relative rounded-radius-lg"
      uderlayClassName="z-[200] bg-interactive-overlay-default"
    >
      <Dialog className=" relative" data-testid="are-you-sure-postal-dialog">
        <RemoveSureModalContent
          ModalTitle={content.areYouSurePopModalTitle}
          ModalContent={content.areYouSurePopModalContent}
          ModalButtonOne={content.areYouSurePopModalButtonOne}
          ModalButtonTwo={content.areYouSurePopModalButtonTwo}
          setIsOpen={setIsOpen}
          onChange={onChange}
        />
      </Dialog>
    </Modal>
  );
}

export default AreYouSurePostalModal;
